var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6666,10c0-1.83331-1.5-3.33331-3.3333-3.33331H6.66665c-1.83334,0-3.33334,1.5-3.33334,3.33331V30c0,1.8334,1.5,3.3334,3.33334,3.3334h26.66665c1.8333,0,3.3333-1.5,3.3333-3.3334V10Zm-2-1.33406l-14.6666,9.66746L5.36764,8.66594h29.29896Zm-14.6666,11.80238L5.36764,11.13503V31.32731h29.29896s0-20.19228,0-20.19228l-14.6666,9.3333Z",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.ed158d36ec87e1e89bc1a094255351a8.svg";